import { useState } from 'react';
import { useInit } from '../../../../Contexts/InitProvider';
import LibModal from '../../../../features/LibModal/LibModal';
import { ConfigureIcon, EditIcon } from '../../../../utils/SVGIcon';
import cn from '../../../../utils/cn';
import ServiceActivityConfigModal from '../Modals/ServiceActivityConfigModal';

function ServiceConfigCard({ title }) {
    const [openModal, setOpenModal] = useState(false);

    const { initInfo } = useInit();

    const { initiate, implement, ongoing, done } = initInfo.steps;

    return (
        <>
            <div
                className={cn(
                    'flex justify-between items-center gap-5 w-full py-3 border-b border-primary-100 overflow-hidden box-border'
                )}
            >
                <div className="flex-initial">
                    <div className="w-11 h-11 rounded-lg flex items-center justify-center bg-primary-100">
                        <ConfigureIcon />
                    </div>
                </div>
                <div className="w-8/12 flex-1">
                    <h3 className="text-primary text-lg font-medium">{title || '--'}:</h3>
                    <span className="text-primary text-sm font-medium">
                        {initiate} &bull; {implement} &bull; {ongoing} &bull; {done}
                    </span>
                </div>
                <button
                    type="button"
                    onClick={() => setOpenModal(true)}
                    className="size-8 p-2 bg-primary-100 rounded-full"
                >
                    <EditIcon />
                </button>
            </div>

            {/* service activity process config */}
            {openModal ? (
                <LibModal title="Service activity process configuration" setOpen={setOpenModal}>
                    <ServiceActivityConfigModal closeModal={() => setOpenModal(false)} />
                </LibModal>
            ) : null}
        </>
    );
}

export default ServiceConfigCard;
